const themePath = `@/themes/${process.env.VUE_APP_THEME || 'schedulingplus'}`

export const importView = viewPath =>
  import(`${themePath}/views/${viewPath}`)
    .catch(() => import(`@/views/${viewPath}`))
